import axios from 'axios';

export default class ImageService {
    doGetAll() {
        return axios.get(`/api/all-path-images`);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/image-service.js